import { z } from 'zod';
import { Column } from './column';

export const ListMetadata = z.object({
  id: z.string(),
  siteId: z.string(),
  name: z.string(),
  columns: z.record(
    z.object({
      id: z.string(),
      name: z.string(),
      hash: z.string()
    })
  )
});

export type ListMetadata = z.infer<typeof ListMetadata>;

export const Metadata = z.object({
  lists: z.record(ListMetadata)
});

export type Metadata = z.infer<typeof Metadata>;

export type List<N extends string = string, Builder extends Record<string, Column> = Record<string, Column>> = {
  meta: { id: N };
  columns: Builder;
};

type ListBuilder = <S extends string, Builder extends Record<string, Column>>(
  id: S,
  builder: Builder
) => List<S, Builder>;

export const list: ListBuilder = (id, builder) => ({
  meta: { id },
  columns: builder
});

export type EnrichedFields<L extends List> = { [K in keyof L['columns']]?: z.output<L['columns'][K]['parse']> };
